// PGCET MBA Mocks 2–9: each lives in quiz/mba-mockN with its own intro and
// test page. Their questions store the right answer as an option index; the
// profile works with letters, so results are saved (and reviewed) in the same
// shape as Mock 1: testName "PGCET MBA Mock Test", `result.mock` = N and a
// breakdown keyed by question id 1–100.
import getApiBaseUrl from "../utils/api";
import { mba2AllQuestions } from "./mba-mock2/mba2data";
import { mba3AllQuestions } from "./mba-mock3/mba3data";
import { mba4AllQuestions } from "./mba-mock4/mba4data";
import { mba5AllQuestions } from "./mba-mock5/mba5data";
import { mba6AllQuestions } from "./mba-mock6/mba6data";
import { mba7AllQuestions } from "./mba-mock7/mba7data";
import { mba8AllQuestions } from "./mba-mock8/mba8data";
import { mba9AllQuestions } from "./mba-mock9/mba9data";

const LETTERS = "ABCDE";
const letter = (index) => (index === undefined || index === null ? null : LETTERS[index]);

const MOCK_QUESTIONS = {
  2: mba2AllQuestions,
  3: mba3AllQuestions,
  4: mba4AllQuestions,
  5: mba5AllQuestions,
  6: mba6AllQuestions,
  7: mba7AllQuestions,
  8: mba8AllQuestions,
  9: mba9AllQuestions,
};

// Mock 1 (quiz/pgcet-mba-test) plus the mocks above.
export const PGCET_MBA_MOCK_COUNT = 1 + Object.keys(MOCK_QUESTIONS).length;

// Questions with lettered options ("A. …"), as the profile review expects.
export const getPgcetMbaReviewQuestions = (mock) =>
  (MOCK_QUESTIONS[mock] || []).map((q) => ({
    id: q.id,
    question: q.question,
    options: q.options.map((o, i) => `${LETTERS[i]}. ${o}`),
    answer: letter(q.correct),
  }));

export const pgcetMbaBreakdown = (questions, answers) =>
  Object.fromEntries(
    questions.map((q) => [
      q.id,
      { user: letter(answers[q.id]), correct: letter(q.correct), isCorrect: answers[q.id] === q.correct },
    ])
  );

export const savePgcetMbaResult = async (mock, questions, answers, score, totalMarks) => {
  try {
    const response = await fetch(`${getApiBaseUrl()}/tests/save`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        testName: "PGCET MBA Mock Test",
        result: {
          mock,
          score,
          total: totalMarks,
          percentage: Math.round((score / totalMarks) * 100),
          breakdown: pgcetMbaBreakdown(questions, answers),
        },
      }),
    });
    if (!response.ok) console.error(`PGCET MBA Mock ${mock} result not saved (${response.status})`);
  } catch (err) {
    console.error("Save failed:", err);
  }
};
